import cn from 'classnames';

import { CheckMark, Remove } from '@webapp/common/assets/icons';

import css from './actions.css';

export const Actions: FC<{
    onRemove?: (e: any) => void;
    onPurge?: (e: any) => void;
    onCancel?: (e: any) => void;
    onAccept?: (e: any) => void;
    cancelText?: string;
    acceptText?: string;
}> = ({ acceptText, cancelText, onAccept, onCancel, onPurge, onRemove }) => (
    <div className={css.actions}>
        {onRemove && (
            <div className={cn(css.action, css.remove)}>
                <button className={css.btn} onClick={onRemove}>
                    Удалить
                </button>
            </div>
        )}
        {onPurge && (
            <div className={cn(css.action, css.purge)}>
                <button className={css.btn} onClick={onPurge}>
                    <Remove />
                    <span>Удалить</span>
                </button>
            </div>
        )}
        {onCancel && (
            <div className={cn(css.action, css.cancel)}>
                <button className={css.btn} onClick={onCancel}>
                    {cancelText || 'Отмена'}
                </button>
            </div>
        )}
        {onAccept && (
            <div className={cn(css.action, css.accept)}>
                <button className={css.btn} onClick={onAccept}>
                    <span>{acceptText || 'Принять'}</span>
                    <CheckMark />
                </button>
            </div>
        )}
    </div>
);
